import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { ProductImage } from './ProductImage';
export function Hero() {
  return <section className="bg-white px-4 pt-5 pb-6 border-b-4 border-brand-navy" data-id="element-88" data-mp="9ktchjcqjuvn">
      <div className="max-w-3xl mx-auto text-center" data-id="element-89" data-mp="9ipaj6yed5y0">
        <h1 className="font-display text-[27px] leading-[1.05] sm:text-4xl md:text-5xl text-brand-navy mb-2.5" data-id="element-90" data-mp="4mi4le603ug2">
          The Complete Ready-to-Teach System for Physical Education Teachers
        </h1>

        <p className="font-heading font-semibold text-[15px] sm:text-lg text-brand-ink leading-snug mb-1.5 max-w-2xl mx-auto" data-id="element-91" data-mp="xbflbcukdj6p">
          Stop spending hours planning PE lessons, searching for activities and
          rebuilding classes every week.
        </p>

        <p className="text-sm sm:text-base text-brand-slate font-medium leading-snug mb-3 max-w-2xl mx-auto" data-id="element-92" data-mp="3d1ik78o21amw">
          Get ready-to-teach lessons, activities, skill progressions, fitness
          sessions, management tools and assessment resources — all in one
          professional system.
        </p>

        <ProductImage className="max-w-[300px] sm:max-w-md mb-3" alt="PE Teacher Pro complete 6-in-1 ready-to-teach system box set" data-id="element-93" data-mp="3o7c1c19oavi7" />

        <CTAButton className="max-w-md mx-auto" data-id="element-94" data-mp="39a378zszjdms">
          🏃 YES! I WANT THE COMPLETE SYSTEM
        </CTAButton>

        <p className="mt-2 inline-flex items-center gap-1.5 text-xs sm:text-sm font-heading font-bold text-brand-navy" data-id="element-95" data-mp="3eb90qzugz4xd">
          <ShieldCheckIcon className="w-4 h-4 text-brand-green" aria-hidden="true" data-id="element-96" data-mp="358hmksa7lv21" />
          🛡️ 14-Day Money-Back Guarantee
        </p>
      </div>
    </section>;
}